<h1>Metadata komponenty / poznámka</h1>
<fieldset>
  <strong>Metadata komponenty</strong>

  <div class="column-100">
    <label>Název komponenty</label>
    <div class="info">{{ component.baseName }}</div>

    <label>Číslo jednací dokumentu EPD</label>
    <div class="info">{{ component.document.referenceNumber || '-'}}</div>

    <label>MPV ID</label>
    <div class="info">{{ component.id }}</div>

    <label>Způsob vytvoření komponenty</label>
    <div class="info">{{ component.sourceType | documentSourceTypeName }}</div>

    <label>Vytvořeno</label>
    <div class="info">{{ component.timestamp | date : 'short' }}</div>

    <label>Změněno</label>
    <div class="info">{{ component.updatedTimestamp | date : 'short' }}</div>

    <label>Vytvořil</label>
    <div class="info">{{ component.createdUser | username:false :false}}</div>

    <label>Změnil</label>
    <div class="info">{{ component.updatedUser | username:false :false}}</div>
  </div>
</fieldset>

<fieldset>
  <div class="column-100">
    <label [ngClass]="{ required: canManipulate && canEdit && component.sourceType !== 'MPV_GENERATED' && component.sourceType !== 'MPV_EDITED' && component.sourceType !== 'MPV_INSERTED' }">Typ komponenty</label>
    <gmt-select
      *ngIf="canManipulate && canEdit && component.sourceType !== 'MPV_GENERATED' && component.sourceType !== 'MPV_EDITED' && component.sourceType !== 'MPV_INSERTED'"
      [optionItems]="attachmentTypes"
      [multiselect]="false"
      [data]="this"
      [itemPipe]="attachmentTypePipe"
      field="attachmentType"
    ></gmt-select>

    <div class="info" *ngIf="!canManipulate || !canEdit || component.sourceType === 'MPV_GENERATED' || component.sourceType === 'MPV_EDITED' || component.sourceType === 'MPV_INSERTED'">
      <span *ngIf="attachmentType">{{ attachmentType | attachmentType : 'title'}}</span>
    </div>

    <label>Poznámka</label>
    <div class="info">
      <div *ngIf="!canEdit" class="ck-editor__editable ck-content" [innerHTML]="component.note | safeHtml"></div>
      <div id="editor"></div>
    </div>
  </div>
</fieldset>

<div class="text-center pt-20">
  <gmt-button [clickAction]="onUpdate" [gmtDisabled]="!canEdit || !isValid()">Uložit</gmt-button>
  <gmt-button [clickAction]="onCancel" class="red">Zrušit</gmt-button>
</div>
